module.exports = __webpack_public_path__ + "img/youtube.e45710f1.svg";